import { Injectable } from "@angular/core";
import { CookieService } from "ngx-cookie-service";

@Injectable({ providedIn: 'root' })
export class PushNotificationsUtil {
    constructor(private cookieService: CookieService) { }

    enableChatNotifications(): void {
        this.cookieService.set('chat-notifications-active', 'true', {
            secure: true,
        });
    }

    disableChatNotifications(): void {
        this.cookieService.set('chat-notifications-active', 'false', {
            secure: true,
        });
    }

    isChatNotificationsActive(): boolean {
        const active = this.cookieService.get('chat-notifications-active')
        return active === 'true'
    }
}